import { Button, Col, Divider, Modal, Row, Space, Table, Typography, InputNumber } from 'antd';
import { ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import React, { FC, useCallback, useMemo, useState } from 'react';
import Link from 'antd/lib/typography/Link';
import { useParams } from 'react-router';
import { AutoCompleteInput } from '../../../../../form/adapters/AutoCompleteInput';
const { confirm } = Modal;
const { Text } = Typography;

type Props = {
  internalCustomers: {
    criteriaSet: { id: number; name: string; criterias: any[] };
    criteriaSetName: string;
    internalCustomer: { id: number; value: string };
    internalCustomerName: string;
    key: number;
    weight?: number;
    reviewType?: 'all' | 'lead' | 'member';
    type: 'team' | 'user';
    user?: number;
    status?: string;
  }[];
  criteriaSet: any[];
  userSet: any[];
  onChange: (reviewers: {
    entityId: number;
    criteriaSetId: number;
    type: 'team' | 'user';
    weight: number;
    reviewType: 'all' | 'lead' | 'member';
    user?: number;
  }) => void;
  leader?: boolean;
  leadId?: number;
};

export const SubordinateReviewManger: FC<Props> = (props) => {
  const { internalCustomers, criteriaSet, userSet, onChange, leader, leadId } = props;

  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [modalVisible1, setModalVisible1] = useState<boolean>(false);
  const [selectedInternalCustomer, setSelectedInternalCustomer] = useState<{
    id: number;
    value: string;
  }>();
  const [selectedOldInternalCustomer, setSelectedOldInternalCustomer] = useState<{
    id: number;
    value: string;
  }>();
  const [internalValue, setInternalValue] = useState<number | undefined>();
  const [reviewType, setReviewType] = useState<'all' | 'lead' | 'member'>('all');
  const [weight, setWeight] = useState<number>(0);
  const [selectedStatus, setSelectedStatus] = useState<string | undefined>();
  const params = useParams<{ cycle: string; id: string; name: string }>();
  const columns = useMemo(() => {
    return [
      {
        title: 'Subordinate',
        dataIndex: 'internalCustomerName',
        key: 'internalCustomer',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <div>
            <Link
              onClick={() => {
                setInternalValue(record?.criteriaSet?.id);
                setSelectedInternalCustomer(record?.internalCustomer);
                setSelectedOldInternalCustomer(record?.internalCustomer);
                setWeight(record?.weight ?? 0);
                setReviewType(record?.reviewType ?? 'all');
                setSelectedStatus(record?.status);
                setModalVisible1(true);
              }}>
              {text}
            </Link>
          </div>
        ),
      },
      {
        title: 'Criteria Set',
        dataIndex: 'criteriaSetName',
        key: 'criteriaSet',
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Text>{record.type === 'team' ? 'Team' : 'User'}</Text>
        ),
      },
      {
        title: 'Weight',
        dataIndex: 'weight',
        key: 'weight',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => <Text>{record.weight}</Text>,
      },
      {
        title: 'Percentage',
        dataIndex: 'weight',
        key: 'percentage',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Text>
            {isNaN(
              (+record.weight /
                internalCustomers
                  .filter((e) => e.user === leadId)
                  .reduce((x, y) => x + +(y?.weight ?? 0), 0)) *
                100,
            )
              ? '0.00 '
              : (
                  (+record.weight /
                    internalCustomers
                      .filter((e) => e.user === leadId)
                      .reduce((x, y) => x + +(y?.weight ?? 0), 0)) *
                  100
                ).toFixed(2)}{' '}
            %
          </Text>
        ),
      },
    ];
  }, [internalCustomers, leadId]);

  const showDeleteConfirm = useCallback(() => {
    confirm({
      title: `Deleting Subordinate!`,
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure delete this Subordinate?`,
      okText: 'Yes,Delete!',
      centered: true,
      okType: 'primary',
      cancelText: 'Cancel',
      onOk: function () {
        const internalUsers: any[] = internalCustomers
          .filter((e) => e.type === 'user')
          .filter(
            (item) =>
              !(
                item?.internalCustomer?.id === selectedOldInternalCustomer?.id &&
                item?.user === leadId
              ),
          )
          .map((item1) =>
            item1?.user
              ? {
                  entityId: item1?.internalCustomer?.id,
                  criteriaSetId: item1?.criteriaSet?.id,
                  type: 'user',
                  weight: item1?.weight ?? 0,
                  reviewType: item1?.reviewType ?? 'all',
                  user: item1?.user,
                }
              : {
                  entityId: item1?.internalCustomer?.id,
                  criteriaSetId: item1?.criteriaSet?.id,
                  type: 'user',
                  weight: item1?.weight ?? 0,
                  reviewType: item1?.reviewType ?? 'all',
                },
          );
        const reviewers: {
          entityId: number;
          criteriaSetId: number;
          type: 'team' | 'user';
          weight: number;
          reviewType: 'all' | 'lead' | 'member';
          user?: number;
        }[] = [...internalUsers];

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        onChange(reviewers);
        setInternalValue(undefined);
        setSelectedInternalCustomer(undefined);
        setSelectedOldInternalCustomer(undefined);
        setModalVisible(false);
        setWeight(0);
        setReviewType('all');
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }, [internalCustomers, leadId, onChange, selectedOldInternalCustomer?.id]);

  const setInternalCustomerValues = useCallback(() => {
    if (selectedInternalCustomer && internalValue) {
      const items2: {
        entityId: number;
        criteriaSetId: number;
        type: 'team' | 'user';
        weight: number;
        reviewType: 'all' | 'lead' | 'member';
        user?: number;
      }[] = internalCustomers
        .filter((e) => e.type === 'user')
        ?.filter(
          (item) =>
            !(item?.internalCustomer?.id === selectedInternalCustomer?.id && item?.user === leadId),
        )
        .map((item) =>
          item?.user
            ? {
                entityId: item.internalCustomer.id,
                criteriaSetId: item.criteriaSet.id,
                type: 'user',
                weight: item?.weight ?? 0,
                reviewType: item?.reviewType ?? 'all',
                user: item?.user,
              }
            : {
                entityId: item.internalCustomer.id,
                criteriaSetId: item.criteriaSet.id,
                type: 'user',
                weight: item?.weight ?? 0,
                reviewType: item?.reviewType ?? 'all',
              },
        );
      const reviewers = leadId
        ? [
            ...items2,
            {
              entityId: selectedInternalCustomer.id,
              criteriaSetId: internalValue,
              type: 'user',
              weight: weight,
              reviewType: reviewType,
              user: leadId,
            },
          ]
        : [
            ...items2,
            {
              entityId: selectedInternalCustomer.id,
              criteriaSetId: internalValue,
              type: 'user',
              weight: weight,
              reviewType: reviewType,
            },
          ];
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onChange(reviewers);
      setInternalValue(undefined);
      setSelectedInternalCustomer(undefined);
      setModalVisible(false);
      setWeight(0);
      setReviewType('all');
    }
  }, [
    internalCustomers,
    internalValue,
    leadId,
    onChange,
    reviewType,
    selectedInternalCustomer,
    weight,
  ]);

  const editInternalCustomerValues = useCallback(() => {
    if (selectedInternalCustomer && internalValue) {
      const items: {
        entityId: number;
        criteriaSetId: number;
        type: 'team' | 'user';
        weight: number;
        reviewType: 'all' | 'lead' | 'member';
        user?: number;
      }[] = internalCustomers
        .filter((e) => e.type === 'team')
        ?.filter(
          (item) =>
            !(
              item?.internalCustomer?.id === selectedOldInternalCustomer?.id &&
              item?.user === leadId
            ),
        )
        .map((item) =>
          item?.user
            ? {
                entityId: item.internalCustomer.id,
                criteriaSetId: item.criteriaSet.id,
                type: 'team',
                weight: item?.weight ?? 0,
                reviewType: item?.reviewType ?? 'all',
                user: item?.user,
              }
            : {
                entityId: item.internalCustomer.id,
                criteriaSetId: item.criteriaSet.id,
                type: 'team',
                weight: item?.weight ?? 0,
                reviewType: item?.reviewType ?? 'all',
              },
        );
      const items2: {
        entityId: number;
        criteriaSetId: number;
        type: 'team' | 'user';
        weight: number;
        reviewType: 'all' | 'lead' | 'member';
        user?: number;
      }[] = internalCustomers
        .filter((e) => e.type === 'user')
        ?.filter(
          (item) =>
            !(
              item?.internalCustomer?.id === selectedOldInternalCustomer?.id &&
              item?.user === leadId
            ),
        )
        .map((item) =>
          item?.user
            ? {
                entityId: item.internalCustomer.id,
                criteriaSetId: item.criteriaSet.id,
                type: 'user',
                weight: item?.weight ?? 0,
                reviewType: item?.reviewType ?? 'all',
                user: item?.user,
              }
            : {
                entityId: item.internalCustomer.id,
                criteriaSetId: item.criteriaSet.id,
                type: 'user',
                weight: item?.weight ?? 0,
                reviewType: item?.reviewType ?? 'all',
              },
        );
      const reviewers = leadId
        ? [
            ...items,
            ...items2,
            {
              entityId: selectedInternalCustomer.id,
              criteriaSetId: internalValue,
              type: 'user',
              weight: weight,
              reviewType: reviewType,
              user: leadId,
            },
          ]
        : [
            ...items,
            ...items2,
            {
              entityId: selectedInternalCustomer.id,
              criteriaSetId: internalValue,
              type: 'user',
              weight: weight,
              reviewType: reviewType,
            },
          ];
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onChange(reviewers);
      setInternalValue(undefined);
      setSelectedInternalCustomer(undefined);
      setSelectedOldInternalCustomer(undefined);
      setModalVisible(false);
      setWeight(0);
      setReviewType('all');
    }
  }, [
    internalCustomers,
    internalValue,
    leadId,
    onChange,
    reviewType,
    selectedInternalCustomer,
    selectedOldInternalCustomer,
    weight,
  ]);

  return (
    <div style={{ marginRight: 20, marginLeft: 20 }}>
      <Table
        dataSource={leadId ? internalCustomers.filter((e) => e.user === leadId) : internalCustomers}
        columns={columns}
        pagination={false}
      />
      {!leader && (
        <Button
          type="dashed"
          block
          onClick={() => {
            setModalVisible(true);
          }}>
          <PlusOutlined />
          Add a Subordinate
        </Button>
      )}
      <Modal
        open={modalVisible}
        onCancel={() => {
          setInternalValue(undefined);
          setSelectedInternalCustomer(undefined);
          setModalVisible(false);
        }}
        footer={
          <Row>
            <div style={{ flex: 1 }}>
              <Button
                onClick={() => {
                  setInternalValue(undefined);
                  setSelectedInternalCustomer(undefined);
                  setModalVisible(false);
                  setWeight(0);
                  setReviewType('all');
                }}>
                Cancel
              </Button>
              <Button
                type="primary"
                disabled={!selectedInternalCustomer || !internalValue}
                onClick={() => setInternalCustomerValues()}>
                Save
              </Button>
            </div>
          </Row>
        }
        destroyOnClose>
        <div style={{ marginLeft: 20, marginRight: 20 }}>
          <Row style={{ alignItems: 'center', marginTop: 20 }}>
            <Space>
              <Typography.Title level={5}>User</Typography.Title>
            </Space>
          </Row>
          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
          <Col span={15} style={{ marginBottom: 20 }}>
            <AutoCompleteInput
              id={'user'}
              style={{ display: 'block' }}
              placeholder={`Select Subordinate`}
              onChange={(value: number) => {
                const item = userSet.find((user) => user.id === value);
                if (item) {
                  setSelectedInternalCustomer(item);
                }
              }}
              disabled={leader}
              values={userSet?.filter((e) => e.id !== +params.id)}
              value={selectedInternalCustomer?.id}
            />
          </Col>
          <Row style={{ alignItems: 'center' }}>
            <Space>
              <Typography.Title level={5}>Criteria Set</Typography.Title>
            </Space>
          </Row>
          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
          <Row>
            <Col span={15}>
              <AutoCompleteInput
                style={{ display: 'block' }}
                placeholder="Select Criteria Set"
                onChange={(e: number) => {
                  setInternalValue(e);
                }}
                disabled={leader}
                values={criteriaSet.map((e) => ({ id: e.id, value: e.name }))}
                value={internalValue}
              />
            </Col>
          </Row>
          <Space size={25} />
          <Row>
            <Col span={18}>
              {internalValue &&
                criteriaSet
                  .find((e1) => e1.id == internalValue)
                  .criterias.map((e: any) => (
                    <div
                      key={e.id}
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        border: '1px solid rgba(56,54,48,.16)',
                        marginTop: 5,
                        padding: 5,
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}>
                      <Text>{e.name}</Text>
                    </div>
                  ))}
            </Col>
          </Row>
          <Row style={{ alignItems: 'center', marginTop: 20 }}>
            <Space>
              <Typography.Title level={5}>Weight</Typography.Title>
            </Space>
          </Row>
          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
          <InputNumber
            onChange={(e) => {
              setWeight(e ?? 0);
            }}
            onBlur={(e: any) => {
              setWeight(e.target.value);
            }}
            keyboard={true}
            min={0}
            type={'number'}
            value={weight}
            style={{ width: '50%' }}
          />
        </div>
      </Modal>
      <Modal
        open={modalVisible1}
        onCancel={() => {
          setInternalValue(undefined);
          setSelectedInternalCustomer(undefined);
          setSelectedOldInternalCustomer(undefined);
          setModalVisible1(false);
        }}
        footer={
          <Row>
            {!leader && (
              <Button
                danger
                onClick={() => showDeleteConfirm()}
                disabled={selectedStatus !== 'not submitted' && selectedStatus !== undefined}
                style={{
                  display: selectedInternalCustomer ? 'flex' : 'none',
                }}>
                Delete
              </Button>
            )}
            <div style={{ flex: 1 }}>
              <Button
                onClick={() => {
                  setInternalValue(undefined);
                  setSelectedInternalCustomer(undefined);
                  setSelectedOldInternalCustomer(undefined);
                  setModalVisible1(false);
                  setWeight(0);
                  setReviewType('all');
                }}>
                Cancel
              </Button>
              <Button
                type="primary"
                disabled={!selectedInternalCustomer || !internalValue}
                onClick={() => editInternalCustomerValues()}>
                Edit
              </Button>
            </div>
          </Row>
        }
        destroyOnClose>
        <div style={{ marginLeft: 20, marginRight: 20 }}>
          <Row style={{ alignItems: 'center', marginTop: 20 }}>
            <Space>
              <Typography.Title level={5}>User</Typography.Title>
            </Space>
          </Row>
          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
          <Col span={15} style={{ marginBottom: 20 }}>
            <AutoCompleteInput
              style={{ display: 'block' }}
              placeholder={`Select Subordinate`}
              onChange={(value: number) => {
                const item = userSet.find((user) => user.id === value);
                if (item) {
                  setSelectedInternalCustomer(item);
                }
              }}
              disabled={leader}
              value={selectedInternalCustomer?.id}
              values={
                userSet?.filter((e) => e.id !== +params.id)
                // .filter((e) => !internalCustomerIds.some((e2) => e.id === e2))
              }
            />
          </Col>
          <Row style={{ alignItems: 'center' }}>
            <Space>
              <Typography.Title level={5}>Criteria Set</Typography.Title>
            </Space>
          </Row>
          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
          <Row>
            <Col span={15}>
              <AutoCompleteInput
                style={{ display: 'block' }}
                placeholder="Select Criteria Set"
                onChange={(e: number) => {
                  setInternalValue(e);
                }}
                disabled={leader}
                values={criteriaSet.map((e) => ({ id: e.id, value: e.name }))}
                value={internalValue}
              />
            </Col>
          </Row>
          <Space size={25} />
          <Row>
            <Col span={18}>
              {internalValue &&
                criteriaSet
                  .find((e1) => e1.id == internalValue)
                  .criterias.map((e: any) => (
                    <div
                      key={e.id}
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        border: '1px solid rgba(56,54,48,.16)',
                        marginTop: 5,
                        padding: 5,
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}>
                      <Text>{e.name}</Text>
                    </div>
                  ))}
            </Col>
          </Row>
          <Row style={{ alignItems: 'center', marginTop: 20 }}>
            <Space>
              <Typography.Title level={5}>Weight</Typography.Title>
            </Space>
          </Row>
          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
          <InputNumber
            onChange={(e) => {
              setWeight(e ?? 0);
            }}
            onBlur={(e: any) => {
              setWeight(e.target.value);
            }}
            keyboard={true}
            min={0}
            type={'number'}
            value={weight}
            style={{ width: '50%' }}
          />
        </div>
      </Modal>
    </div>
  );
};
